import { defineFlagKeys } from "@smeetz/utils-feature-flags";

// Bare keys, the "pos" prefix is applied at lookup
// so each resolves to the dashboard flag "pos::<value>"
export const FeatureFlagKeys = defineFlagKeys({
  EndpointsK8sOverride: "endpoints:k8s-override",
  PosSellerPin: "pos-seller-pin",
} as const);

export type FeatureFlagKey =
  (typeof FeatureFlagKeys)[keyof typeof FeatureFlagKeys];
